import axios from "axios";
import { BETTY_ACTION_API } from "./entities";
import { updateErrorAndLoading } from "../actions";
import { isEmpty } from "../util/isEmpty";

export async function get_fcl_drayage_from_bb(terminalInput, rateInput, getstate, dispatch, mode) {
    // console.log("get_fcl_drayage_from_bb.............terminalInput: ",terminalInput,"rateInput: ",rateInput);
    const isUserPresent =  getstate()?.route?.USER_DETAILS?.webuser?.userid != null
    // console.log("rateProfileId: ",rateProfileId,"isUserPresent: ",isUserPresent)
    let jwt_token;
    if(isUserPresent){
        jwt_token = getstate().route.CLIENT_TOKEN.JWT_TOKEN;
    }else{
        jwt_token = getstate().route.JWT_TOKEN.JWT_TOKEN
    }

    const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + jwt_token + "",
    };

    const actionId = isUserPresent
        ? "0d18e8a99cac44a08cebd2e3509ecc41"
        : "cdfd77c0dcd748f7bb598efd4a9f49f1";

    const input = {
        "ratesInput": rateInput,
        "terminalInput": terminalInput
    };

  const query = {
    query: "mutation { action(id: $action_id input: $input) }",
    variables: {
      action_id: actionId,
      input,
    },
  };

  return axios.post(BETTY_ACTION_API, query, { headers }).then((result) => {
    // console.log("---results----",result)
    if (result?.data?.data?.action?.results) {
      const responseData = result?.data?.data?.action?.results || [];
      //console.log("responseData: ",responseData)
      if(responseData === "Service Unavailable"){
        dispatch(updateErrorAndLoading("Service is unavailable at the moment. Please try again later.", undefined));
        return [403, []];
      }
      let deliveryRate = []
      if (responseData) {
        // console.log("responseData: ",responseData);
        // const terminalData = responseData?.terminal;
        const rateData = responseData?.rates
        // console.log("rateData: ",rateData)
        if(rateData && !isEmpty(rateData)){
          const suggestedRate = rateData?.market?.rate
          if(suggestedRate != null){
              const rateLabel = mode === 'pickup' ? 'Pickup' : 'Delivery';
              const chargeTypeId = mode === 'pickup' ? 240 : 33
              deliveryRate.push([rateLabel, "Drayage Rate", suggestedRate, "CTN", suggestedRate, chargeTypeId])
              const accessorials = rateData?.accessorials || [];
              return [200, deliveryRate, accessorials];
          }else{
              return [403, [], []];
          }
        }
      }
    } else if (result?.data?.errors || result?.data?.data?.errors) {
      const errMsg =
        result.data.errors[0].message || result.data.data.errors[0].message;
      console.error(errMsg);
    }
    return [403, [], []];
  });

}
